module.exports = __webpack_public_path__ + "static/img/jf_bg.a43290e7.png";